var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eye_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), /*#__PURE__*/React.createElement("g", {
    id: "eye_svg__Group_21554",
    "data-name": "Group 21554",
    transform: "translate(-892 -804)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_svg__Group_21551",
    "data-name": "Group 21551",
    transform: "translate(894.667 809.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye_svg__Path_17743",
    "data-name": "Path 17743",
    className: "eye_svg__cls-1",
    d: "M15 12a3 3 0 1 1-3-3 3 3 0 0 1 3 3z",
    transform: "translate(-2.458 -4.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye_svg__Path_17744",
    "data-name": "Path 17744",
    className: "eye_svg__cls-1",
    d: "M2.458 12a10 10 0 0 1 19.084 0 10 10 0 0 1-19.084 0z",
    transform: "translate(-2.458 -5)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "eye_svg__Rectangle_19851",
    "data-name": "Rectangle 19851",
    transform: "translate(892 804)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
};

export default SvgEye;